import React from "react";
import {useTheme} from "connectui/theme/ThemeProvider";
import Container from "connectui/component/layout/Container";
import Text from "connectui/component/display/Text";
import FlexContainer from "connectui/component/layout/FlexContainer";
import OutlinedCardBase from "connectui/component/display/card/base/OutlinedCardBase";
import PhoneCard from "./cards/PhoneCard";
import EmailCard from "./cards/EmailCard";
import WhatsAppCard from "./cards/WhatsAppCard";

const MessagingSettingsPanel = ({setStage, data}) => {
  const {theme} = useTheme();
  const cardProps = {
    setStage,
    cardBase: OutlinedCardBase,
    width: "100%",
    maxWidth: "660px",
    height: "100%",
  };

  const renderCard = (CardComponent) => <CardComponent {...cardProps} />;

  return (
    <Container>
      <Text variant="displayXS" weight="semibold">
        Messaging
      </Text>
      <Container padding={`${theme.spacing(10)} 0`}>
        <FlexContainer gap={theme.spacing(5)} flexDirection="column">
          {renderCard(EmailCard)}
          {renderCard(PhoneCard)}
          {renderCard(WhatsAppCard)}
        </FlexContainer>
      </Container>
    </Container>
  );
};

export default MessagingSettingsPanel;
